import React from 'react';
import PropTypes from 'prop-types';
import logo from 'assets/img/phone-white.png';

const Header = ({ title }) => {
  return (
    <div className="w-100 flex justify-center">
      <div className="w-100 title-form-tab flex justify-center items-center flex-column">
        <img className="icon-tab dn pb2" src={logo} alt="Phone" />
        <label className="label-tab">{title}</label>
      </div>
    </div>
  );
};

Header.propTypes = {
  title: PropTypes.string
};

export default Header;
